<template>
  <form @submit.prevent="submit">
    <Field
      label="Container ID"
      @input="$v.resource.gtm_id.$touch()"
      @handleChange="handleChange"
      v-model="resource.gtm_id"
      :error="gtm_idError"
      placeholder="GTM-XXXXXXX"/>

    <div class="btn-save">
      <Btn :class="{'changes-made': changesMade}">Save Changes</Btn>
    </div>
  </form>
</template>

<script>
import form from '@/mixins/form'

import Btn from '@/components/Btn'

import {errorMessages} from '@/lib/error_messages'

export default {
  name: 'SiteGtmForm',

  mixins: [form],

  components: {
    Btn
  },

  computed: {
    ...errorMessages([
      'gtm_id'
    ])
  },

  validations: {
    resource: {
      gtm_id: {}
    }
  }
}
</script>
